<template>
  <section id="Grupos" class="section-item">
    <h1>{{ $t("title.groups") }}</h1>

    <section id="api-Grupos-PostContactsGroups">
      <h2>{{ $t("title.groups") }} - {{ $t("title.create_group") }}</h2>
      <p>{{ $t("groups.create_group_method") }}</p>
      <div class="">
        <div class="put type">post</div>
        <pre> <code class="url language-bash">https://{{ whitelabel?.api_domain }}/v1/contacts/groups</code></pre>
      </div>
      <div class="code-toggle">
        <button
          @click="selectedTab = 'json'"
          :class="{ active: selectedTab === 'json' }"
        >
          JSON
        </button>
        <button
          @click="selectedTab = 'curl'"
          :class="{ active: selectedTab === 'curl' }"
        >
          cURL
        </button>
      </div>

      <pre v-if="selectedTab === 'curl'">
            <code class="language-bash">curl -XPOST -H "Content-type: application/json" -d '{"name":"Grupo de contatos","description":"Grupo de contatos"}' 'https://{{ whitelabel?.api_domain }}/v1/contacts/groups'
-u '[SEU ID]:[SEU TOKEN]'</code>
          </pre>

      <pre v-if="selectedTab === 'json'">
            <code class="language-json">{   
   "name":"Marketing",
   "description":"Contatos de marketing"
}</code>
          </pre>

      <h3>{{ $t("general.header") }}</h3>
      <table>
        <thead>
          <tr>
            <th>{{ $t("general.field") }}</th>
            <th>{{ $t("general.type") }}</th>
            <th>{{ $t("general.description") }}</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Content-Type</td>
            <td>String</td>
            <td>
              {{ $t("general.default_value") }}
              <span class="app-json">application/json</span>
            </td>
          </tr>
        </tbody>
      </table>

      <h3>{{ $t("general.parameter") }}</h3>
      <table>
        <thead>
          <tr>
            <th>{{ $t("general.field") }}</th>
            <th>{{ $t("general.type") }}</th>
            <th>{{ $t("general.description") }}</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>name</td>
            <td>String</td>
            <td>{{ $t("table.group_name") }}</td>
          </tr>
          <tr>
            <td>description</td>
            <td>String</td>
            <td>{{ $t("table.description-group") }}</td>
          </tr>
        </tbody>
      </table>

      <h3>Success 200</h3>
      <table>
        <thead>
          <tr>
            <th>{{ $t("general.field") }}</th>
            <th>{{ $t("general.type") }}</th>
            <th>{{ $t("general.description") }}</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>name</td>
            <td>String</td>
            <td>{{ $t("table.group_name") }}</td>
          </tr>
          <tr>
            <td>description</td>
            <td>String</td>
            <td>{{ $t("table.description-group") }}</td>
          </tr>
          <tr>
            <td>account_id</td>
            <td>String</td>
            <td>{{ $t("table.account_id_created_group") }}</td>
          </tr>
          <tr>
            <td>id</td>
            <td>String</td>
            <td>{{ $t("table.group_id_created") }}</td>
          </tr>
          <tr>
            <td>created_at</td>
            <td>String</td>
            <td>{{ $t("table.group_created_at") }}</td>
          </tr>
          <tr>
            <td>updated_at</td>
            <td>String</td>
            <td>{{ $t("table.group_updated_at") }}</td>
          </tr>
        </tbody>
      </table>

      <button class="btn02">{{ $t("general.success") }}</button>

      <pre>
            <code class="language-json">HTTP/1.1 200 OK
{
   "name":"Marketing",
   "description":"Contatos de marketing",
   "account_id":"f98c24gd-8239-4c4f-a2e8-143f26820f58",
   "id":"3164512a-6f4a-46ff-9cdd-e14607001ad8",
   "updated_at":"2020-08-04T13:29:58.000000Z",
   "created_at":"2020-08-04T13:29:58.000000Z"
}</code>
          </pre>

      <button class="btn02">Error-Response</button>
      <pre>
            <code class="language-json">{
      "error": "Error message"
}</code>
          </pre>
    </section>

    <section id="api-Grupos-DeleteContactsGroups">
      <h2>{{ $t("title.groups") }} - {{ $t("title.delete_groups") }}</h2>
      <p>{{ $t("sms.group_deletion_method") }}</p>
      <div class="">
        <div class="delete type">DELETE</div>
        <pre> <code class="url language-bash">https://{{ whitelabel?.api_domain }}/v1/contacts/groups</code></pre>
      </div>
      <div class="code-toggle">
        <button
          @click="selectedTab = 'json'"
          :class="{ active: selectedTab === 'json' }"
        >
          JSON
        </button>
        <button
          @click="selectedTab = 'curl'"
          :class="{ active: selectedTab === 'curl' }"
        >
          cURL
        </button>
      </div>

      <pre v-if="selectedTab === 'curl'">
            <code class="language-bash">curl -XDELETE -H "Content-type: application/json" -d '{"ids":["3164512a-6f4a-46ff-9cdd-e14619001ad8"]}' 'https://{{ whitelabel?.api_domain }}/v1/contacts/groups'
-u '[SEU ID]:[SEU TOKEN]'</code>
          </pre>

      <pre v-if="selectedTab === 'json'">
            <code class="language-json">{   
  "ids": [
    "9864512a-6f4a-46ff-6cdd-e14619001ad7",
    "1964512a-0D4a-16ff-9cdd-a14219001ad1"
  ]  
}</code>
          </pre>

      <h3>{{ $t("general.header") }}</h3>
      <table>
        <thead>
          <tr>
            <th>{{ $t("general.field") }}</th>
            <th>{{ $t("general.type") }}</th>
            <th>{{ $t("general.description") }}</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Content-Type</td>
            <td>String</td>
            <td>
              {{ $t("general.default_value") }}
              <span class="app-json">application/json</span>
            </td>
          </tr>
        </tbody>
      </table>

      <h3>{{ $t("general.parameter") }}</h3>
      <table>
        <thead>
          <tr>
            <th>{{ $t("general.field") }}</th>
            <th>{{ $t("general.type") }}</th>
            <th>{{ $t("general.description") }}</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>ids</td>
            <td>Array</td>
            <td>{{ $t("table.group_ids_to_delete") }}</td>
          </tr>
        </tbody>
      </table>

      <button class="btn02">{{ $t("general.success") }}</button>

      <pre>
            <code class="language-json">HTTP/1.1 200 OK
{
  "message":"grupo excluido"
}</code>
          </pre>

      <button class="btn02">Error-Response</button>
      <pre>
            <code class="language-json">{
      "error": "Error message"
    }</code>
          </pre>
    </section>

    <section id="api-Grupos-DeleteContactsGroupsId">
      <h2>{{ $t("title.groups") }} - {{ $t("title.exclude_id") }}</h2>
      <p>{{ $t("groups.delete_group_by_id_method") }}</p>
      <div class="">
        <div class="delete type">DELETE</div>
        <pre> <code class="url language-bash">https://{{ whitelabel?.api_domain }}/v1/contacts/groups/:id</code></pre>
      </div>

      <h3>{{ $t("general.header") }}</h3>
      <table>
        <thead>
          <tr>
            <th>{{ $t("general.field") }}</th>
            <th>{{ $t("general.type") }}</th>
            <th>{{ $t("general.description") }}</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Content-Type</td>
            <td>String</td>
            <td>
              {{ $t("general.default_value") }}
              <span class="app-json">application/json</span>
            </td>
          </tr>
        </tbody>
      </table>

      <h3>{{ $t("general.parameter") }}</h3>
      <table>
        <thead>
          <tr>
            <th>{{ $t("general.field") }}</th>
            <th>{{ $t("general.type") }}</th>
            <th>{{ $t("general.description") }}</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>id</td>
            <td>String</td>
            <td>{{ $t("table.group_id_to_be_deleted") }}</td>
          </tr>
        </tbody>
      </table>
    </section>

    <section id="api-Grupos-GetContactsGroups">
      <h2>{{ $t("title.groups") }} - {{ $t("title.list_groups") }}</h2>
      <p>{{ $t("groups.list_groups_method") }}</p>
      <div class="">
        <div class="get type">GET</div>
        <pre> <code class="url language-bash">https://{{ whitelabel?.api_domain }}/v1/contacts/groups</code></pre>
      </div>

      <div class="code-toggle">
        <button class="curl">cURL</button>
      </div>

      <pre>
            <code class="language-bash">curl -XGET -H "Content-type: application/json" 'https://{{ whitelabel?.api_domain }}/v1/contacts/groups'
-u '[SEU ID]:[SEU TOKEN]'</code>
          </pre>

      <h3>{{ $t("general.header") }}</h3>
      <table>
        <thead>
          <tr>
            <th>{{ $t("general.field") }}</th>
            <th>{{ $t("general.type") }}</th>
            <th>{{ $t("general.description") }}</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Content-Type</td>
            <td>String</td>
            <td>
              {{ $t("general.default_value") }}
              <span class="app-json">application/json</span>
            </td>
          </tr>
        </tbody>
      </table>

      <h3>Success 200</h3>
      <table>
        <thead>
          <tr>
            <th>{{ $t("general.field") }}</th>
            <th>{{ $t("general.type") }}</th>
            <th>{{ $t("general.description") }}</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>data</td>
            <td>Array</td>
            <td>{{ $t("table.group_array_returned") }}</td>
          </tr>
          <tr>
            <td>name</td>
            <td>String</td>
            <td>{{ $t("table.group_name") }}</td>
          </tr>
          <tr>
            <td>description</td>
            <td>String</td>
            <td>{{ $t("table.description-group") }}</td>
          </tr>
          <tr>
            <td>account_id</td>
            <td>String</td>
            <td>{{ $t("table.account_id_created_group") }}</td>
          </tr>
          <tr>
            <td>id</td>
            <td>String</td>
            <td>{{ $t("table.group_id") }}</td>
          </tr>
          <tr>
            <td>created_at</td>
            <td>String</td>
            <td>{{ $t("table.group_created_at") }}</td>
          </tr>
          <tr>
            <td>updated_at</td>
            <td>String</td>
            <td>{{ $t("table.group_updated_at") }}</td>
          </tr>
          <tr>
            <td>contacts_count</td>
            <td>Number</td>
            <td>{{ $t("table.group_contact_count") }}</td>
          </tr>
          <tr>
            <td>current_page</td>
            <td>Number</td>
            <td>{{ $t("table.current_page") }}</td>
          </tr>
          <tr>
            <td>first_page_url</td>
            <td>String</td>
            <td>{{ $t("table.first_page_url") }}</td>
          </tr>
          <tr>
            <td>from</td>
            <td>Number</td>
            <td>{{ $t("table.element_limit_min") }}</td>
          </tr>
          <tr>
            <td>last_page</td>
            <td>Number</td>
            <td>{{ $t("table.last_page_number") }}</td>
          </tr>
          <tr>
            <td>last_page_url</td>
            <td>String</td>
            <td>{{ $t("table.last_page_url") }}</td>
          </tr>
          <tr>
            <td>next_page_url</td>
            <td>String</td>
            <td>{{ $t("table.next_page_url") }}</td>
          </tr>
          <tr>
            <td>path</td>
            <td>String</td>
            <td>{{ $t("table.base_url") }}</td>
          </tr>
          <tr>
            <td>per_page</td>
            <td>Number</td>
            <td>{{ $t("table.max_groups_per_page") }}</td>
          </tr>
          <tr>
            <td>prev_page_url</td>
            <td>String</td>
            <td>{{ $t("table.prev_page_url") }}</td>
          </tr>
          <tr>
            <td>to</td>
            <td>Number</td>
            <td>{{ $t("table.element_limit_max") }}</td>
          </tr>
          <tr>
            <td>total</td>
            <td>Number</td>
            <td>{{ $t("table.groups_returned_count") }}</td>
          </tr>
        </tbody>
      </table>

      <button class="btn02">{{ $t("general.success") }}</button>
      <pre>
            <code class="language-json">HTTP/1.1 200 OK
{
  "current_page": 1,
  "data": [
    {      
      "id": "3164512a-6f4a-46ff-9cdd-e14619001ad8",
      "name": "Marketing",
      "description": "Contatos de marketing",
      "account_id": "f18c24ad-8339-4c4f-a2e8-143f27420f58",
      "created_at": "2020-08-04T13:29:58.000000Z",
      "updated_at": "2020-08-04T13:29:58.000000Z",
      "contacts_count": 2
    }
  ],
  "first_page_url": "http://localhost:8080/v1/contacts/groups?page=1",
  "from": 1,
  "last_page": 1,
  "last_page_url": "http://localhost:8080/v1/contacts/groups?page=1",
  "next_page_url": null,
  "path": "http://localhost:8080/v1/contacts/groups",
  "per_page": 10,
  "prev_page_url": null,
  "to": 3,
  "total": 1
}</code>
          </pre>

      <button class="btn02">Error-Response</button>
      <pre>
            <code class="language-json">{
      "error": "Error message"
    }</code>
          </pre>
    </section>

    <section id="api-Grupos-GetContactsGroupsId">
      <h2>{{ $t("title.groups") }} - {{ $t("title.get_by_id") }}</h2>
      <p>{{ $t("groups.get_group_by_id_method") }}</p>
      <div class="">
        <div class="get type">GET</div>
        <pre> <code class="url language-bash">https://{{ whitelabel?.api_domain }}/v1/contacts/groups/:id</code></pre>
      </div>

      <div class="code-toggle">
        <button class="curl">cURL</button>
      </div>

      <pre v-if="selectedTab === 'curl'">
            <code class="language-bash">curl -XGET -H "Content-type: application/json" 'https://{{ whitelabel?.api_domain }}/v1/contacts'
  -u '[SEU ID]:[SEU TOKEN]'</code>
          </pre>

      <h3>{{ $t("general.header") }}</h3>
      <table>
        <thead>
          <tr>
            <th>{{ $t("general.field") }}</th>
            <th>{{ $t("general.type") }}</th>
            <th>{{ $t("general.description") }}</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Content-Type</td>
            <td>String</td>
            <td>
              {{ $t("general.default_value") }}
              <span class="app-json">application/json</span>
            </td>
          </tr>
        </tbody>
      </table>

      <h3>{{ $t("general.parameter") }}</h3>
      <table>
        <thead>
          <tr>
            <th>{{ $t("general.field") }}</th>
            <th>{{ $t("general.type") }}</th>
            <th>{{ $t("general.description") }}</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>id</td>
            <td>String</td>
            <td>{{ $t("table.group_id") }}</td>
          </tr>
        </tbody>
      </table>

      <h3>Success 200</h3>
      <table>
        <thead>
          <tr>
            <th>{{ $t("general.field") }}</th>
            <th>{{ $t("general.type") }}</th>
            <th>{{ $t("general.description") }}</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>name</td>
            <td>String</td>
            <td>N{{ $t("table.group_name") }}</td>
          </tr>
          <tr>
            <td>description</td>
            <td>String</td>
            <td>{{ $t("table.description-group") }}</td>
          </tr>
          <tr>
            <td>account_id</td>
            <td>String</td>
            <td>{{ $t("table.account_id_created_group") }}</td>
          </tr>
          <tr>
            <td>id</td>
            <td>String</td>
            <td>{{ $t("table.group_id_created") }}</td>
          </tr>
          <tr>
            <td>created_at</td>
            <td>String</td>
            <td>{{ $t("table.group_created_at") }}</td>
          </tr>
          <tr>
            <td>updated_at</td>
            <td>String</td>
            <td>{{ $t("table.group_updated_at") }}</td>
          </tr>
        </tbody>
      </table>

      <button class="btn02">{{ $t("general.success") }}</button>
      <pre>
            <code class="language-json">HTTP/1.1 200 OK
{
  "name": "Grupo",
  "description": "text",
  "account_id": "d811ae1c-b079-45be-bec6-a659f2462e29",
  "id": "23029640-95d8-4207-8229-31891cbd4d12",
  "updated_at": "2021-11-17T20:50:18.000000Z",
  "created_at": "2021-11-17T20:50:18.000000Z"
}</code>
          </pre>
    </section>
  </section>
</template>

<script>
import hljs from "highlight.js";
import "highlight.js/styles/an-old-hope.css";

export default {
  name: "GroupComponent",
  data() {
    return {
      selectedTab: "json",
    };
  },
  mounted() {
    this.highlightCode();
  },
  watch: {
    selectedTab() {
      this.$nextTick(() => {
        this.highlightCode();
      });
    },
  },
  methods: {
    highlightCode() {
      document.querySelectorAll("pre code").forEach((block) => {
        hljs.highlightBlock(block);
      });
    },
  },
};
</script>

<style scoped>
.sms-method {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 1rem;
}

pre[class*="language-"] {
  background-color: #000 !important;
  color: var(--green-code);
  padding: 10px;
  border-radius: 8px;
  border: 1px solid #ccc;
  overflow-x: auto;
  white-space: pre-wrap;
  font-family: var(--font-code);
  margin-bottom: 20px;
}
</style>
